import React, { createContext, useContext } from 'react';
import { useRouter } from 'next/router';
import {
  createI18n,
  I18NContext,
  LocaleProvider,
} from '@spotify-internal/i18n-core';

const backend = {
  type: 'backend' as const,
  async read(lang: string, _ns: any, callback: any) {
    try {
      // fallback to inline strings when loading english
      if (lang === 'en') {
        return callback(null, {});
      }
      return callback(
        null,
        await import(`./translations/${lang}/strings.json`),
      );
    } catch (err) {
      // fallback to inlined strings on error
      return callback(null, {});
    }
  },
};

interface I18nProviderProps {
  children: React.ReactNode;
}

export const I18nProvider = ({ children }: I18nProviderProps) => {
  const i18n = createI18n({}, backend);
  const { locale } = useRouter();
  const localeToUse = !locale || locale === 'en-US' ? 'en' : locale;

  return (
    <I18NContext.Provider value={i18n}>
      <LocaleProvider value={localeToUse}>{children}</LocaleProvider>
    </I18NContext.Provider>
  );
};

export const I18nContext = createContext(createI18n());

export const useI18nContext = () => {
  return useContext(I18nContext);
};

export default I18nProvider;
